import React from 'react';
import { formatCurrency, getCartTotals } from '../utils/cart';

function CartSummary({ selectedCount, selectedProducts, onClear, onConfirm, submitting }) {
  const { totalQuantity, totalAmount } = getCartTotals(selectedProducts);

  return (
    <div className={`cart-summary ${selectedCount > 0 ? 'visible' : ''}`}>
      <div className="cart-content">
        <div className="cart-bottom-row">
          <div className="cart-info">
            <span className="cart-count">
              {selectedCount} item{selectedCount !== 1 ? 's' : ''}
            </span>
            <span className="cart-text">
              {totalQuantity > selectedCount
                ? `(${totalQuantity} total quantity)`
                : 'selected'
              }
            </span>
            <span className="cart-total">{formatCurrency(totalAmount)}</span>
          </div>
          <div className="cart-actions">
            <button className="clear-btn" onClick={onClear} disabled={submitting}>
              Clear All
            </button>
            <button
              className="confirm-btn"
              onClick={onConfirm}
              disabled={selectedCount === 0}
            >
              Review Cart →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CartSummary;
